import { i18n, notify } from "@dehub/theme";
import { humanizeError } from "./humanize-error";

const success = (message: string) => {
  notify.success({ title: i18n.t("common:success"), message });
};

const error = (message: string) => {
  // The 3 s duplicate suppression lives in notify.error (theme).
  notify.error({ title: i18n.t("error.title", { ns: "common" }), message: humanizeError(message) });
};

export const message = {
  success,
  error,
};
